<template>
    <div>
        <v-dialog v-model="show" @click:outside="close" width="950">
            <!--<v-container fluid style="padding: 0px!important;overflow: hidden;">-->
            <div class="modal">
                <v-row>
                    <v-col cols="1" class="icon-modal remove" style="max-width: 32px!important;"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="9" class="d-flex flex-md-row flex-colum justify-space-between" style="    padding-top: 8px;
    padding-bottom: 26px;">
                        <v-col cols="12" md="12" class="text-center">
                            <v-btn
                                    rounded
                                    depressed
                                    class="btn-azul text-center btn-billing2"
                                    style="width: 155px!important;"
                                    @click="open_pdf(url)"
                            >Download
                            </v-btn>
                        </v-col>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <!--<v-spacer></v-spacer>-->
                </v-row>
                <v-row>
                    <v-col cols="1" class="icon-modal remove" style="max-width: 32px!important;"></v-col>
                    <v-col cols="11" class="text-center">
                        <div id="page-loader">Please wait while we generate the preview ...</div>
                        <div>
                            <canvas id="pdf-canvas" width="930" >
                            </canvas>
                        </div>
                    </v-col>
                </v-row>


            </div>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        props: ['show', 'hide', 'url', 'sender_profile_picture_invoice'],
        components: {
        },
        data() {
            return {

            }
        },
        methods: {
            close: function () {
                this.hide();
                let _CANVAS = document.querySelector('#pdf-canvas');
                let context = _CANVAS.getContext('2d');
                context.clearRect(0,0,_CANVAS.width, _CANVAS.height);
                document.querySelector("#page-loader").style.display = 'block';
            },
            open_pdf(url){
                window.open(url, '_blank')
            }
        },
    };
</script>